import {
    DOWNLOAD_PROVISIONING_DATA_ERROR,
    DOWNLOAD_PROVISIONING_DATA_RESET,
    DOWNLOAD_PROVISIONING_DATA_START,
    DOWNLOAD_PROVISIONING_DATA_SUCCESS
} from "../../actions/services/cct/provisioning-export";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export function provisioningData(state = defaultState, { type, payload, error }) {
    switch (type) {
        case DOWNLOAD_PROVISIONING_DATA_START:
            return {
                ...defaultState,
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case DOWNLOAD_PROVISIONING_DATA_SUCCESS:
            return {
                ...defaultState,
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                payload
            };
        case DOWNLOAD_PROVISIONING_DATA_ERROR:
            return {
                ...defaultState,
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: {
                        code: error.code,
                        message: error.message
                    }
                }
            };
        case DOWNLOAD_PROVISIONING_DATA_RESET:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}
